<div class="modal fade" id={{modelId}} tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-dialog-scrollable" id="modal">
        <div class="modal-content">
            <div class="modal-body">
                <div class="row modal-heading-row">
                    <div class="row heading-row-right">
                        <img src="../../../../../assets/icons/logo.png" width="35px" height="32px"
                            class="d-inline-block align-top" alt="" loading="lazy" data-dismiss="modal">
                        <div class="modal-Heading">
                            {{modalName}}
                        </div>
                    </div>
                    <img src="../../../../../assets/icons/closeBlack.png" width="18px" height="18px"
                        style="cursor: pointer;" class="d-inline-block align-top" alt="" loading="lazy"
                        data-dismiss="modal" (click)="onCancelClick()">
                </div>
                <hr>
                <div>
                    <div class="modal-form">
                        <form [formGroup]="zoneTableForm" #data>
                            <div class="row firstMainRow">
                                <div class="col-2" style="font-size: 14px;  padding-right: 0; padding-left: 0; ">
                                    <div class="rightInput imageContainer">
                                        <img class="zoneImages"
                                            [src]="profileURl == '' && zoneTableForm.controls['thumbnail'].value == null ? '../../../../../assets/images/addPhoto.png' : profileURl != '' ? profileURl : zoneTableForm.controls['thumbnail'].value" />
                                        <input type="file" class="custom-file-input fileInput editIcon" id="customFile"
                                            name="myfile" (change)="addImage($event)" #UploadFileInput
                                            accept="image/png, image/jpeg" />
                                        <img class="editIcon" href="#customFile"
                                            src="../../../../../assets/icons/editBackgroundpng.png" />
                                    </div>
                                </div>
                                <div class="col-4 inputColTwin"
                                    style="font-size: 14px;  padding-right: 0; padding-left: 0; ">
                                    <div class="rightInput">
                                        <label class="lblInput" for="fontWeight">Zone Name</label><span
                                            style="color: red;">*</span>
                                        <input type="text" placeholder="Zone Name" class="form-control input"
                                            formControlName='name' style="height: 52px; font-size: 14px;"
                                            [ngClass]="{ 'is-invalid': submitted && setZoneControls.name.errors}">
                                    </div>
                                    <div *ngIf="submitted && setZoneControls.name.errors" class="text-danger">
                                        Zone name is required
                                    </div>
                                </div>
                                <div class="col-4 inputColTwin"
                                    style="font-size: 14px;  padding-right: 0; padding-left: 0; ">
                                    <div class="rightInput">
                                        <label class="lblInput" for="fontWeight">Zone Description</label><span
                                            style="color: red;">*</span>
                                        <textarea type="text" placeholder="Zone Description"
                                            class="form-control textarea" formControlName='description'
                                            [ngClass]="{ 'is-invalid': submitted && setZoneControls.description.errors}"
                                            style="height: 42px; font-size: 14px;"></textarea>
                                    </div>
                                    <div *ngIf="submitted && setZoneControls.name.errors" class="text-danger">
                                        Zone description is required
                                    </div>
                                </div>
                            </div>
                            <div class="row mainRow">
                                <div class="col col-11 mainSections marginTop">
                                    <div class="col col-8">
                                        <h5 class="headingText">Available online</h5>
                                        <h5 class="descText">Enabled: This location will be available for customers to
                                            reserve online</h5>
                                    </div>
                                </div>
                                <div class="col col-1 actionContainer marginTop">
                                    <ui-switch size="small" switchColor="white" color="#00c10b" defaultBgColor="white"
                                        uncheckedLabel="Off" checkedLabel="On" checkedTextColor="white"
                                        (changeEvent)="updateSwitch('available_online')"
                                        [(ngModel)]="zoneData.available_online" [ngModelOptions]="{standalone: true}"
                                        defaultBoColor="#cccccc">
                                    </ui-switch>
                                </div>
                            </div>
                            <div class="row mainRow">
                                <div class="col col-8 mainSections marginTop">
                                    <div class="col col-12">
                                        <h5 class="headingText">Maximum duration of a reservation (mins)</h5>
                                        <h5 class="descText">This is the time a customer(s) will usually stay at your
                                            restaurant</h5>
                                    </div>
                                </div>
                                <div class="col col-3 actionContainer marginTop">
                                    <input type="number" placeholder="Maximum duration" class="form-control input"
                                        style="height: 52px; font-size: 14px;" formControlName='max_duration'
                                        [ngClass]="{ 'is-invalid': submitted && setZoneControls.max_duration.errors}">
                                </div>
                                <div *ngIf="submitted && setZoneControls.max_duration.errors" class="text-danger">
                                    Maximum duration is required
                                </div>
                            </div>
                            <div class="row mainRow">
                                <div class="col col-11 mainSections marginTop">
                                    <div class="col col-8">
                                        <h5 class="headingText">Force manual confirmation for all bookings</h5>
                                        <h5 class="descText">Enabled: Restaurant must manually accept all bookings for
                                            this location</h5>
                                    </div>
                                </div>
                                <div class="col col-1 actionContainer marginTop">
                                    <ui-switch size="small" switchColor="white" color="#00c10b" defaultBgColor="white"
                                        uncheckedLabel="Off" checkedLabel="On" checkedTextColor="white"
                                        defaultBoColor="#cccccc" (changeEvent)="updateSwitch('manual_accept')"
                                        [(ngModel)]="zoneData.manual_accept" [ngModelOptions]="{standalone: true}">
                                    </ui-switch>
                                </div>
                            </div>
                            <div class="row mainRow">
                                <div class="col col-11 mainSections marginTop">
                                    <div class="col col-8">
                                        <h5 class="headingText">Force a deposit payment</h5>
                                        <h5 class="descText">Enabled: Customer is required to pay a deposit when making
                                            the booking</h5>
                                    </div>
                                </div>
                                <div class="col col-1 actionContainer marginTop">
                                    <ui-switch size="small" switchColor="white" color="#00c10b" defaultBgColor="white"
                                        uncheckedLabel="Off" checkedLabel="On" checkedTextColor="white"
                                        defaultBoColor="#cccccc" (changeEvent)="updateSwitch('force_deposit')"
                                        [(ngModel)]="zoneData.force_deposit" [ngModelOptions]="{standalone: true}">
                                    </ui-switch>
                                </div>
                            </div>
                            <div class=" mainRow" style="margin-top: 10px;" *ngIf="zoneData.force_deposit">
                                <div class="col col-11 mainSections marginTop" style="border-left: 5px solid #0B4791;">
                                    <div class="col-3 col-left columnContainer">
                                        <label class="headingText">Amount £</label>
                                        <input class="form-control" type="number" placeholder="Amount"
                                            formControlName='deposit_amount'
                                            [ngClass]="{ 'is-invalid': submitted && setZoneControls.deposit_amount.errors}">
                                        <div class="text-danger">
                                            <div class="" *ngIf="submitted && setZoneControls.deposit_amount.errors">
                                                Amount is required </div>
                                        </div>
                                    </div>

                                    <div class="col col-3 col-left columnContainer">
                                        <label class="headingText">Deposit Type</label>
                                        <select class="custom-select mr-sm-2" formControlName="deposit_type"
                                            style=" font-size: 14px;" id="inlineFormCustomSelect"
                                            [ngClass]="{ 'is-invalid': submitted && setZoneControls.deposit_type.errors}">
                                            <option value='PER_HEAD' selected>PER_HEAD</option>
                                            <option value="TABLE">TABLE</option>
                                        </select>
                                        <div class="text-danger">
                                            <div *ngIf="submitted && setZoneControls.deposit_type.errors">
                                                Deposit type is required
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col col-4 col-left columnContainer">
                                        <label class="headingText">Customer Refundable?</label>
                                        <select class="custom-select mr-sm-2" formControlName="is_refundable"
                                            style=" font-size: 14px;" id="inlineFormCustomSelect"
                                            [ngClass]="{ 'is-invalid': submitted && setZoneControls.is_refundable.errors}">
                                            <option value=1 selected>Yes</option>
                                            <option value=0>No</option>
                                        </select>
                                        <div class="text-danger">
                                            <div *ngIf="submitted && setZoneControls.is_refundable.errors">
                                                Customer Refundable is required
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mainRow">
                                <div class="col col-11 mainSections marginTop">
                                    <div class="col col-8">
                                        <h5 class="headingText">Auto allocate tables</h5>
                                        <h5 class="descText">Enabled: Customers will be automatically allocated a table
                                            based on party size.
                                            Disabled: Customers can select their table.</h5>
                                    </div>
                                </div>
                                <div class="col col-1 actionContainer marginTop">
                                    <ui-switch size="small" switchColor="white" color="#00c10b" defaultBgColor="white"
                                        uncheckedLabel="Off" checkedLabel="On" checkedTextColor="white"
                                        defaultBoColor="#cccccc" (changeEvent)="updateSwitch('auto_allocate_slot')"
                                        [(ngModel)]="zoneData.auto_allocate_slot" [ngModelOptions]="{standalone: true}">
                                    </ui-switch>
                                </div> 
                            </div>
                            <div class="row mainRow">
                                <div class="col col-8 mainSections marginTop">
                                    <div class="col col-12">
                                        <h5 class="headingText">Add tables in this zone</h5>
                                        <h5 class="descText">Add all the available tables and the seating capacity per
                                            table in this zone. 'Min party size' is the minimum amount of people who can
                                            book this table. </h5>
                                    </div>
                                </div>
                                <div class="col col-4 actionContainer marginTop">
                                    <button class="btn btn-primary" style="cursor: pointer;" type="button"
                                        class="btn-styles" (click)="addTable()">Add Table</button>
                                </div>
                            </div>
                            <div class="row subRow" formGroupName="tables">
                                <div class="col col-12">
                                    <table class="table" style="border-spacing: 0px !important; margin-top: 10px;">
                                        <thead style="border-spacing: 0px !important;">
                                            <tr>
                                                <!-- Table Heading -->
                                                <th scope="col col-2" class="tableHeader">Table Name/No</th>
                                                <th scope="col col-3" class="tableHeader">Table capacity </th>
                                                <th scope="col col-3" class="tableHeader">Minimum Party Size </th>
                                                <th scope="col col-4" style="width: 16%;" class="tableHeader"></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr class="tableData" *ngFor="let tbs of allAddedTables">
                                                <td class="tableData">
                                                    <input class="form-control" type="text" placeholder="Name"
                                                        formControlName={{tbs.name}} 
                                                         [ngClass]="{ 'is-invalid': submitted && setZoneControls['tables'].get(tbs.name).errors }">
                                                            <div class="text-danger">
                                                    <div class="" *ngIf="submitted && setZoneControls['tables'].get(tbs.name).errors" style="font-size: 12px;">
                                                        Name is required </div>
                                                    </div>
                                                </td>
                                                <td class="tableData">
                                                    <input class="form-control" type="number" placeholder="Seat Count"
                                                        formControlName={{tbs.seat_count}}
                                                            [ngClass]="{ 'is-invalid': submitted && setZoneControls['tables'].get(tbs.seat_count).errors }">
                                                            <div class="text-danger">
                                                    <div class="" *ngIf="submitted && setZoneControls['tables'].get(tbs.seat_count).errors" style="font-size: 12px;">
                                                        Seat count is required </div>
                                                    </div>
                                                </td>
                                                <td class="tableData">
                                                    <input class="form-control" type="number"
                                                        placeholder="Minimum Party Size"
                                                        formControlName={{tbs.min_count}} [ngClass]="{ 'is-invalid': submitted && setZoneControls['tables'].get(tbs.min_count).errors }">
                                                            <div class="text-danger">
                                                    <div class="" *ngIf="submitted && setZoneControls['tables'].get(tbs.min_count).errors" style="font-size: 12px;">
                                                        Party size is required </div>
                                                    </div>
                                                </td>
                                                <td class="actionBtnContainer tableData">
                                                    <div class="action-btn"
                                                        [style.--backgroundColor]="zoneTableForm.value.tables[tbs.status] == 0 ? '#04D627' : '#FFA41D'"
                                                        (click)="pauseResume(tbs.status)"
                                                        [title]="zoneTableForm.value.tables[tbs.status] == 0 ? 'Play' : 'Pause'">
                                                        <img
                                                            [src]='zoneTableForm.value.tables[tbs.status] == 1  ? "../../../../../../assets/icons/puase.png " : "../../../../../../assets/icons/play.png"' />
                                                    </div>
                                                    <div class="action-btn"
                                                        [style.--backgroundColor]="tbs.id > 1 ? '#E14141' : '#9F9F9E'"
                                                        [title]="'Delete'" (click)="deleteTable(tbs)">
                                                        <img class="deleteIcon"
                                                            src="../../../../../../assets/icons/deleteWhite.png" />
                                                    </div>
                                                </td>

                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="col-md-12 modal-button-div">
                        <button class="btn modal-btn-button" type="button"
                            (click)="modalType == 'Add' ? onAddClick() : onEditClick()">
                            <span *ngIf="!loading">{{modalName == 'Edit Zone(Table)' ? 'Save' : 'Add Zone'}}</span>
                            <div *ngIf="loading" style="position: absolute;">
                                <ngx-spinner bdColor="rgba(255,255,255,0)" size="small" color="#ffffff"
                                    type="ball-clip-rotate" [fullScreen]="false"></ngx-spinner>
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>